export default "__VITE_ASSET__rAmZKLkQ__"